import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { baseUniDriverFactory } from '../../unidriver';

export function PageWrapperUniDriver(base: UniDriver, _body: UniDriver) {
  return {
    getLang: async () => base.attr('lang'),
    getDndKitLiveRegion: (count: number) =>
      base
        .$('[data-hook="modals-container"]')
        .$(`#DndLiveRegion-${count}[role="status"]`),
    ...baseUniDriverFactory(base),
  };
}
